
































import calendarSVG from "../assets/img/calendar.svg";
import dashboardSVG from "../assets/img/dashboard.svg";
import propertiesSVG from "../assets/img/properties.svg";
import clientsSVG from "../assets/img/clients.svg";
import userSVG from "../assets/img/user.svg";
import settingsSVG from "../assets/img/settings.svg";
import logoutSVG from "../assets/img/logout.svg";

import Vue from "vue";

export default Vue.extend({
  name: "Menu",
  methods: {
    logout() {
      this.$cookies.remove("jkt");
      this.$router.push({ name: "login" });
      this.$store.commit("TOGGLE_MENU", false);
    },
  },
  watch: {
    $cookies: {
      handler() {
        this.isOpen = this.$cookies.get("jkt") !== undefined;
      },
      deep: true,
    },
  },
  data() {
    return {
      isOpen: this.$cookies.get("jkt") !== undefined,
      showFooter: false,
    };
  },
  created() {
    //this.$store.commit("TOGGLE_MENU",true);
  },
  components: {
    propertiesSVG,
    userSVG,
    logoutSVG,
  },
});
